import React, { useMemo } from 'react';
import useGoogleTranslate from './hooks/useGoogleTranslate';
import { Container, Image, Row } from 'react-bootstrap';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Router from './route/Router';
import Logo from './Logo';
import { Account } from './Accounts';
import { DataType } from './DataTypes';
import { RECAPTCHA_SITE_KEY } from './Constants';
import Rollbar from './Rollbar';

function App() {
    const year = useMemo(() => new Date().getFullYear(), []);

    const translateRef = useGoogleTranslate();
    return (
        <Rollbar>
            <DataType>
                <Account>
                    <Container className="mx-auto text-right">
                        <div className="py-4 text-center">
                            <Logo />
                        </div>
                        <div id="google_translate_element" ref={translateRef} className="mb-4 col-md-6 mx-auto" />
                    </Container>
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
                        <Container>
                            <Row>
                                <Router />
                            </Row>
                        </Container>
                    </GoogleReCaptchaProvider>
                    <div className="text-center footer py-4">
                        Powered by Link2Feed (Copyright © {year})
                    </div>
                </Account>
            </DataType>
        </Rollbar>
    );
}

export default App;
